import script from "./InternalTicketForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalTicketForm.vue?vue&type=script&setup=true&lang=js"

import "./InternalTicketForm.vue?vue&type=style&index=0&id=3773be59&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3773be59"]])

export default __exports__